import type { RouteObject } from 'react-router';
import { handle } from '@/app/router/handle';

/** /home */
export const homeRoutes: RouteObject = {
  path: 'home',
  handle: handle('home'),
  lazy: () => import('./HomePage').then((m) => ({ Component: m.HomePage })),
};
